import { render, staticRenderFns } from "./VinculatedsFormTab.vue?vue&type=template&id=59e813d4&scoped=true"
import script from "./VinculatedsFormTab.vue?vue&type=script&setup=true&lang=js"
export * from "./VinculatedsFormTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./VinculatedsFormTab.vue?vue&type=style&index=0&id=59e813d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e813d4",
  null
  
)

export default component.exports